<ng-container *ngIf="(currentEmployeeId$ | async) as employeeId">
  <ion-item button lines="full" (click)="goToEmployeeDetails(employeeId)" *ngIf="profileImageOpts$ | async as profileImageOpts">
    <app-profile-image
      slot="start"
      [profileImage]="profileImageOpts"
    ></app-profile-image>
    <ion-label>
      {{ profileImageOpts.name }}
    </ion-label>
    <ion-icon size="small" slot="end" name="open-outline"></ion-icon>
  </ion-item>
</ng-container>
